const { NODE_ENV } = process.env;

export const isDevelopment = NODE_ENV === "development";

export const API_URL = window.location.origin;
//export const alertSec_id = 2125491

//export const API_URL = "https://invento.fasolutions.com";
export const alertSec_id = 2125509;
